



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import { bus } from "@/pages/transitweb/main";
import Speech from "@/components/assistant/Speech.vue";
import { AssistantState } from "@/store/assistant/types";

@Component({
    components: {
        Speech,
    },
})
export default class Message extends Vue {
    @Prop({ default: "" }) private name!: string;
    @Prop({ default: "General" }) private subject!: string;
    @Prop({ default: "" }) private messageRaw!: string;
    @Prop({ default: () => [] }) private images!: any[];
    @Prop({ default: "" }) private role!: string;
    @Prop() private date!: number;
    @Prop({ default: "" }) private status!: string;
    @Prop({ default: false }) private audio_disabled!: boolean;

    @Prop({ default: "#000080" }) private color!: string;

    @State("assistant") assistant!: AssistantState;
    @Action("assistant/setQuestion") setQuestion: any;
    @Action("assistant/askQuestion") askQuestion: any;
    @Getter("assistant/assistantName") assistantName!: string;

    message_content = "";

    mounted() {
        this.updateMessageContent();
    }

    @Watch("messageRaw")
    onMessageRawChanged() {
        this.$nextTick(() => {
            this.updateMessageContent();
        });
    }

    updateMessageContent() {
        const messageElement = this.$refs.message as HTMLElement;

        this.message_content = messageElement
            ? messageElement.textContent || ""
            : "";
    }

    playAudio() {
        (this.$refs.speech as any).onPlaySpeech();
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.message_content);
    }

    get isAssistant() {
        return this.name == this.assistantName;
    }

    editQuestion() {
        this.setQuestion(this.messageRaw);
        bus.$emit("focus_question");
    }
}
